function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 17v4h-2v-3.65L9.72 17H7c-.55 0-1-.45-1-1 0-.56.45-1 1-1h1.12l-1.6-2H4c-.55 0-1-.45-1-1 0-.56.45-1 1-1h.92L2.84 8.4A1 1 0 013 7a.982.982 0 011.4.16l1.6 2V8c0-.56.45-1 1-1 .56 0 1 .45 1 1v3.65l2 2.5V7.4L8 5.43C7.6 5.03 7.6 4.4 8 4a.99.99 0 011.42 0L11 5.6 12.58 4A.99.99 0 0114 4c.4.4.4 1.03 0 1.42l-2 2v3.17l.58-.6a.99.99 0 011.42 0c.4.4.4 1 0 1.4l-2 2v.6c0 .53.45 1 1 1h.6l3.4-3.4L14.42 9c-.4-.4-.4-1 0-1.4.4-.4 1.02-.4 1.4 0l.08.07L17.58 6A.99.99 0 0119 6c.4.4.4 1.03 0 1.42L17.32 9.1l1.08 1.08L19.58 9A.99.99 0 0121 9c.4.4.4 1.03 0 1.42l-1.18 1.18-2.4 2.4h.63c.56 0 1 .45 1 1 0 .56-.44 1-1 1h-2.63L14 17.4V21h-2v-4h-1v-2h2z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationReef = function SvgLocationReef(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationReef;